import React from 'react'

import LabeledSwitch from '../LabeledSwitch/LabeledSwitch'
import { setIsMessageModalOpen, setMessageModalContent } from '../../store/ui/uiSlice'
import { useAppDispatch, useAppSelector } from '../../hooks'

interface Props {
  onChange: (isSelected: boolean) => void
  className?: string
}

const DelayedDeliveryToggle: React.FC<Props> = ({ onChange, className }) => {
  const dispatch = useAppDispatch()
  const { content } = useAppSelector((state) => state.init)
  const { isDelayedDeliverySelected } = useAppSelector((state) => state.ui)
  const { hasBeenFulfilled_fetchPrices_aggregated } = useAppSelector((state) => state.requests)

  if (import.meta.env.VITE_SHOW_DELAYED_DELIVERY !== 'true') return null

  const readMore: string | undefined = content?.delayedDelivery?.readMore

  return (
    <LabeledSwitch
      id="delayed-delivery"
      label={content?.delayedDelivery?.label}
      info={content?.delayedDelivery?.info}
      readMoreText={readMore ? content?.other?.moreInformation : undefined}
      onReadMore={
        readMore
          ? () => {
              dispatch(setMessageModalContent({ dangerouslySetMessage: readMore }))
              dispatch(setIsMessageModalOpen(true))
            }
          : undefined
      }
      checked={isDelayedDeliverySelected}
      // Before the first price there is no configuration to apply the choice to
      disabled={!hasBeenFulfilled_fetchPrices_aggregated}
      onChange={onChange}
      testId="delayed-delivery-toggle"
      className={className}
    />
  )
}

export default DelayedDeliveryToggle
